import React from "react";
import { Tooltip, TooltipProps, useTheme, alpha } from "@mui/material";

interface CustomTooltipProps extends TooltipProps {
    noPadding?: boolean; // nouveau prop pour contrôler le padding
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
    noPadding,
    PopperProps,
    componentsProps,
    ...props
}) => {
    const theme = useTheme();

    return (
        <Tooltip
            {...props}
            PopperProps={{
                container: document.body,
                ...PopperProps,
                style: {
                    zIndex: 1200,
                    ...PopperProps?.style,
                },
            }}
            componentsProps={{
                ...componentsProps,
                tooltip: {
                    ...componentsProps?.tooltip,
                    sx: {
                        ...(noPadding ? { padding: 0 } : {}),
                        backgroundColor:
                            theme.palette.mode === 'dark'
                                ? alpha(theme.palette.grey[800], 0.95)
                                : alpha(theme.palette.background.paper, 0.95),
                        color: theme.palette.text.primary,
                        fontSize: theme.typography.pxToRem(13),
                        lineHeight: 1.5,
                        '& .MuiTypography-root': {
                            fontSize: theme.typography.pxToRem(13),
                            lineHeight: 1.5,
                        },
                        border: '1px solid rgba(145, 158, 171, 0.1)',
                        borderBottom: '1px solid rgba(145, 158, 171, 0.4)',
                        borderColor: theme.palette.divider,
                        boxShadow:
                            theme.palette.mode === 'dark'
                                ? '0 4px 12px rgba(0, 0, 0, 0.3)'
                                : '0 4px 12px rgba(0, 0, 0, 0.1)',
                        ...(componentsProps?.tooltip as any)?.sx,
                    },
                },
                arrow: {
                    ...componentsProps?.arrow,
                    sx: {
                        color:
                            theme.palette.mode === 'dark'
                                ? alpha(theme.palette.grey[800], 0.95)
                                : alpha(theme.palette.background.paper, 0.95),
                        ...(componentsProps?.arrow as any)?.sx,
                    },
                },
            }}
        />
    );
};

export default CustomTooltip;
